enum HttpEndpoint {
    REFRESH_URL = '/auth/refresh',
}

export default HttpEndpoint;
